import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from "@ngx-translate/core";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'feedback-hurt-athlete-dialog',
  templateUrl: 'feedback-hurt-athlete-dialog.html',
  imports: [
    MatDialogModule,
    TranslateModule,
    MatButton,
  ],
  standalone: true
})
export class FeedbackHurtAthleteDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<FeedbackHurtAthleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }
}
